import { Dashboard, DashboardPreference } from '@ddv/models';

export class DashboardWithoutWidgets implements Dashboard {
    id: number | undefined;
    name: string;
    description: string;
    abbreviation: string;
    isGlobal: boolean;
    clientCode: string | undefined;
    createdBy: string;
    createdDate: string;
    updatedDate: string;
    privilege: 'EDIT' | 'VIEW';
    allowInfiniteVScroll: boolean;
    allowInfiniteHScroll: boolean;
    dashboardPreference: DashboardPreference;
    version?: number;

    constructor(init: Partial<Dashboard>) {
        this.id = init.id ?? 0;
        this.name = init.name ?? '';
        this.description = init.description ?? '';
        this.abbreviation = init.abbreviation ?? '';
        this.isGlobal = !!init.isGlobal;
        this.clientCode = init.clientCode;
        this.privilege = init.privilege ?? 'VIEW';
        this.createdBy = init.createdBy ?? '';
        this.createdDate = init.createdDate ?? '';
        this.updatedDate = init.updatedDate ?? '';
        this.allowInfiniteVScroll = !!init.allowInfiniteVScroll;
        this.allowInfiniteHScroll = !!init.allowInfiniteHScroll;
        this.dashboardPreference = init.dashboardPreference ?? init.dashboardPreferences?.[0] ?? {};
        this.version = init.version;
    }

    getAllFundCodes(): { code: string }[] {
        return this.dashboardPreference?.funds?.map((fund) => ({ code: fund.fundId })) ?? [];
    }
}

export function emptyDashboardWithoutWidgets(): DashboardWithoutWidgets {
    return new DashboardWithoutWidgets({});
}
